// data/events.js

// Liste aller möglichen Einsatzgebiete
export const allEventTypes = [
  {
    name: 'Firmenfeier',
    description: 'Teambuilding, Jubiläen',
    icon: 'business',
    category: 'business'
  },
  {
    name: 'Hochzeit',
    description: 'Die perfekte Erinnerung für das Brautpaar',
    icon: 'wedding',
    category: 'private'
  },
  {
    name: 'Geburtstag',
    description: 'Für unvergessliche Momente',
    icon: 'birthday',
    category: 'private'
  },
  {
    name: 'Einschulung',
    description: 'Ein besonderer Tag im Leben',
    icon: 'school',
    category: 'education'
  },
  {
    name: 'Jugendweihe',
    description: 'Festlicher Anlass für junge Menschen',
    icon: 'celebration',
    category: 'private'
  },
  {
    name: 'JGA',
    description: 'Spaß vor dem großen Tag',
    icon: 'party',
    category: 'private'
  },
  {
    name: 'Sommerfest',
    description: 'Open-Air-Veranstaltungen',
    icon: 'summer',
    category: 'seasonal'
  },
  {
    name: 'Weihnachtsfeier',
    description: 'Festliche Stimmung einfangen',
    icon: 'christmas',
    category: 'seasonal'
  },
  {
    name: 'Messeveranstaltung',
    description: 'Mehr Aufmerksamkeit für Ihren Stand',
    icon: 'exhibition',
    category: 'business'
  },
  {
    name: 'Kundenveranstaltung',
    description: 'Besonderer Service für Ihre Kunden',
    icon: 'customer',
    category: 'business'
  },
  {
    name: 'Tag der offenen Tür',
    description: 'Besucher begeistern und binden',
    icon: 'openday',
    category: 'business'
  },
  {
    name: 'Sportveranstaltung',
    description: 'Siegesmomente festhalten',
    icon: 'sports',
    category: 'special'
  },
  {
    name: 'Vereinsfeier',
    description: 'Gemeinschaft stärken',
    icon: 'team',
    category: 'community'
  },
  {
    name: 'Vereinsjubiläum',
    description: 'Besondere Meilensteine feiern',
    icon: 'anniversary',
    category: 'community'
  },
  {
    name: 'Jubiläum',
    description: 'Für jedes Firmenjubiläum geeignet',
    icon: 'milestone',
    category: 'business'
  },
  {
    name: 'Abiball',
    description: 'Den Abschluss gebührend feiern',
    icon: 'graduation',
    category: 'education'
  },
  {
    name: 'Abschlussfeier',
    description: 'Erfolge würdigen und festhalten',
    icon: 'certificate',
    category: 'education'
  }
]

// Funktion, die zufällig eine bestimmte Anzahl an Eventtypen zurückgibt
export function getRandomEventTypes(count = 6) {
  // Kopie des Arrays erstellen, um das Original nicht zu verändern
  const shuffled = [...allEventTypes]
  
  // Fisher-Yates Shuffle Algorithmus
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1))
    ;[shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]]
  }
  
  // Die ersten 'count' Elemente zurückgeben
  return shuffled.slice(0, count)
}

// SVG-Icons für die verschiedenen Event-Typen
export const eventIcons = {
  wedding: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M8 19h8a1 1 0 0 0 1-1v-9a3 3 0 0 0-3-3h-4a3 3 0 0 0-3 3v9a1 1 0 0 0 1 1z"></path>
    <path d="M6 12h0"></path>
    <path d="M18 12h0"></path>
    <path d="M12 3v3"></path>
    <path d="M10 3h4"></path>
    <path d="m15 7-3-3-3 3"></path>
  </svg>`,
  
  birthday: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M20 10h-5.5"></path>
    <path d="M13 7h.5"></path>
    <path d="M14 4h.5"></path>
    <path d="M15 13h.5"></path>
    <path d="M7 2v2"></path>
    <path d="M9 2v6"></path>
    <path d="M11 2v8"></path>
    <path d="M3 8h13"></path>
    <path d="M3 20c0-6 7-12 7-12"></path>
    <path d="m21 20-4-4"></path>
    <path d="m17 20 4-4"></path>
  </svg>`,
  
  business: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
  </svg>`,
  
  school: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M22 10v6M2 10l10-5 10 5-10 5z"></path>
    <path d="M6 12v5c3 3 9 3 12 0v-5"></path>
  </svg>`,
  
  celebration: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M5.8 11.3L2 22l10.7-3.79"></path>
    <path d="M4 3h.01"></path>
    <path d="M22 8h.01"></path>
    <path d="M15 2h.01"></path>
    <path d="M22 20h.01"></path>
    <path d="M22 2l-2.24 3.37a2 2 0 0 0 2.24 2.93L22 2z"></path>
    <path d="M17 8l-4.74 7.11a2 2 0 0 0 3.19 2.37L17 8z"></path>
    <path d="M11 15l-7 5"></path>
  </svg>`,
  
  party: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M5.5 20H8M17 9l-4.172.938a1 1 0 0 0-.774 1.219L13 14"></path>
    <path d="M21.107 3.893c.03 1.717-.707 3.57-2.192 5.056l-2.085 2.085a7 7 0 0 0-1.149 1.516L14 16"></path>
    <path d="M17 3.5 18.5 2"></path>
    <path d="M19.5 6 21 4.5"></path>
    <path d="M16 7 8.85 14.15"></path>
    <path d="M10 16c-1.608 1.608-5 1-5 1s-.608-3.392 1-5c1.608-1.608 5-1 5 1Z"></path>
  </svg>`,
  
  summer: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <circle cx="12" cy="12" r="4"></circle>
    <path d="M12 2v2"></path>
    <path d="M12 20v2"></path>
    <path d="m4.93 4.93 1.41 1.41"></path>
    <path d="m17.66 17.66 1.41 1.41"></path>
    <path d="M2 12h2"></path>
    <path d="M20 12h2"></path>
    <path d="m6.34 17.66-1.41 1.41"></path>
    <path d="m19.07 4.93-1.41 1.41"></path>
  </svg>`,
  
  christmas: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M12 2v8"></path>
    <path d="m4.48 10 2-1"></path>
    <path d="m17.5 9 2 1"></path>
    <path d="M4 22h16"></path>
    <path d="M10 22V16l-3.5-1.5L10 13l2 1 2-1 3.5 1.5L14 16v6"></path>
    <path d="M12 13v3"></path>
  </svg>`,
  
  exhibition: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M8 3H5a2 2 0 0 0-2 2v3"></path>
    <path d="M8 21H5a2 2 0 0 1-2-2v-3"></path>
    <path d="M16 3h3a2 2 0 0 1 2 2v3"></path>
    <path d="M16 21h3a2 2 0 0 0 2-2v-3"></path>
    <path d="M12 4v16"></path>
    <path d="M4 12h16"></path>
  </svg>`,
  
  customer: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M14 19a6 6 0 0 0-12 0"></path>
    <circle cx="8" cy="9" r="4"></circle>
    <path d="M22 19a6 6 0 0 0-6-6 4 4 0 1 0 0-8"></path>
  </svg>`,
  
  openday: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M3 10h18"></path>
    <path d="M6 14h12"></path>
    <path d="M10 18h4"></path>
    <rect x="4" y="2" width="16" height="20" rx="2"></rect>
  </svg>`,
  
  sports: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <circle cx="12" cy="12" r="10"></circle>
    <path d="m4.93 4.93 4.24 4.24"></path>
    <path d="m14.83 9.17 4.24-4.24"></path>
    <path d="m14.83 14.83 4.24 4.24"></path>
    <path d="m9.17 14.83-4.24 4.24"></path>
    <circle cx="12" cy="12" r="4"></circle>
  </svg>`,
  
  team: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
    <circle cx="9" cy="7" r="4"></circle>
    <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
    <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
  </svg>`,
  
  anniversary: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line>
    <line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
    <path d="M8 14h.01"></path>
    <path d="M12 14h.01"></path>
    <path d="M16 14h.01"></path>
    <path d="M8 18h.01"></path>
    <path d="M12 18h.01"></path>
    <path d="M16 18h.01"></path>
  </svg>`,
  
  milestone: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M20 8h-9a2 2 0 0 0-2 2v10"></path>
    <path d="M7 8a2 2 0 0 1 2-2h5"></path>
    <path d="M14 2h-4a2 2 0 0 0-2 2"></path>
    <path d="M13 16v-4h-4"></path>
    <path d="M2 22V8h10"></path>
  </svg>`,
  
  graduation: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M12 2v8"></path>
    <path d="M2 10h20"></path>
    <path d="M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8z"></path>
    <path d="M8 22h8"></path>
    <path d="M12 16v6"></path>
  </svg>`,
  
  certificate: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-5 h-5">
    <path d="M20 8h-2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2Z"></path>
    <path d="M16 8h-2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h2"></path>
    <path d="M20 8v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V8"></path>
    <path d="M16 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"></path>
    <path d="M12 16v3"></path>
  </svg>`
}

// Funktion um das passende Icon für einen Event-Typ zu erhalten
export function getEventIcon(iconName) {
  return eventIcons[iconName] || eventIcons.celebration // Fallback-Icon
}